<script lang="ts">
  import { Card, LeftNavigation, TopNavigation } from "$components";
  import type { NavbarEntry } from "$shared/lib/navbar";
  import { MyPagesStartModel } from "$models";
  const isLoadedFromApp =
    new URLSearchParams(window.location.search).get("app") === "true";
  const navbarEntries: NavbarEntry[] = [
    {
      label: "Mina sidor",
      hash: "#/",
    },
  ];
</script>

{#if !isLoadedFromApp}
  <TopNavigation masqUrl="/404.html" {navbarEntries} env="mypages" />
{/if}
<div
  id="page"
  class="
    min-h-fit
    m-auto max-w-[1280px] px-[8px] pb-[24px] flex flex-col h-screen justify-between {
    isLoadedFromApp
    ? 'pt-[8px]'
    : 'pt-[74px]'
    }
  "
>
  <Card
    customClass="max-mobile:bg-transparent max-mobile:border-none max-mobile:shadow-none"
  >
    <div class="flex">
      <LeftNavigation
        data={new MyPagesStartModel({
          agreements: [],
          applicants: [],
          debtors: [],
          sites: [],
          spotShares: [],
        })}
      />
      <div class="w-full">
        <slot />
      </div>
    </div>
  </Card>
  <p
    class="text-[12px] text-[#9FB1B2] w-full text-center py-[32px] max-mobile:hidden"
  >
    © Parkdando AB {new Date().getFullYear()}
  </p>
</div>
